import {
  inValidRange,
  isValidLanguages,
  objComparison,
  validFormats,
  validLevels
} from "../utils";

export const checkColumnStructure = (newCerts, currentColumns) => {
  const currentColIds = Object.keys(currentColumns)
  newCerts.forEach( newCert => {
    if (!currentColIds.includes(newCert.position)) return false
  })
  return true
}

export const checkCertsStructure = (items) => {
  const emptyItem = { id: "", name: "", organization: "", description: "",  duration: "", price: 0, skills_group: [], created: "", updated: "", position: "" }

  return items.every( item => objComparison(item, emptyItem))
}

export const addMissingCertKeys = (cert) => {
  return {
    ...cert,
    type_format: cert.type_format || "",
    role_of_the_ecsf: cert.role_of_the_ecsf || [],
    domain: cert.domain || [],
    main_topics: cert.main_topics || "",
    level: cert.level || "",
    prerequisites: cert.prerequisites || "",
    iso_17024: cert.iso_17024 || 0,
    language: cert.language || [],
    link: cert.link || "",
  }
}

export const verifyCertValues = (cert, ranges) => {
  return {
    ...cert,

    role_of_the_ecsf: (inValidRange(cert.role_of_the_ecsf, ranges.maxEcsf)) ? cert.role_of_the_ecsf : [],
    domain: (inValidRange(cert.domain, ranges.maxDomain)) ? cert.domain : [],
    skills_group: (inValidRange(cert.skills_group, ranges.maxSkillGroup)) ? cert.skills_group : [],
    language: (isValidLanguages(cert.language)) ? cert.language : [],
    type_format: (validFormats.includes(cert.type_format)) ? cert.type_format : "",
    levels: (validLevels.includes(cert.level)) ? cert.level : "",
  }
}